import { render, staticRenderFns } from "./NlpFooter.vue?vue&type=template&id=45b520ee&scoped=true"
import script from "./NlpFooter.vue?vue&type=script&lang=js"
export * from "./NlpFooter.vue?vue&type=script&lang=js"
import style0 from "./NlpFooter.vue?vue&type=style&index=0&id=45b520ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b520ee",
  null
  
)

export default component.exports